// extracted by mini-css-extract-plugin
export default {"left-navigation":"RootLayout_left-navigation__lAL-h","contentWrapper":"RootLayout_contentWrapper__zH56f"};